import { Component } from '@angular/core';
import { ThemeService, NotificationMiddlewareService, TitleService, AuthService, AppConfig } from 'channn-lib';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { ResponsiveHelperComponent } from './shared/components/responsive-helper/responsive-helper.component';
import { AiAssistantHostComponent } from './shared/components/ai-assistant/ai-assistant-host.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { filter, map } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [NgClass, RouterOutlet, ResponsiveHelperComponent, AiAssistantHostComponent, NgxSpinnerModule],
})
export class AppComponent {
    dataMenu: any;

    /** Chỉ bật chatbot khi config.application.isAiAssistant === true */
    readonly isAiAssistantEnabled: boolean = AppConfig.config?.application?.isAiAssistant === true;

    constructor(
        public themeService: ThemeService,
        public _notificationMiddleware: NotificationMiddlewareService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private _titleService: TitleService,
        private _authService: AuthService,
    ) {
        this.dataMenu = this._authService.currentMenuValue;
    }

    ngOnInit() {
        this._notificationMiddleware.init();
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd), // Chỉ quan tâm đến sự kiện NavigationEnd
                map(() => {
                    let child = this.activatedRoute.firstChild;
                    while (child.firstChild) {
                        child = child.firstChild;
                    }
                    // Lấy tiêu đề từ data của route
                    if (child.snapshot.paramMap.get('IDMenu')) {
                        return this.renderTitleMenu(child.snapshot.paramMap.get('IDMenu'));
                    }
                    if (child.snapshot.paramMap.get('menuID')) {
                        return this.renderTitleMenu(child.snapshot.paramMap.get('menuID'));
                    }
                    return 'TMS'; // Tiêu đề mặc định nếu không tìm thấy tiêu đề trong route
                }),
            )
            .subscribe((title: string) => {
                this._titleService.setTitle(title);
            });
    }

    renderTitleMenu(menuID) {
        menuID = parseInt(menuID);
        let dataFilter = this.dataMenu.filter((x) => x.ID == menuID);
        if (dataFilter.length > 0) {
            return dataFilter[0]['label'];
        }
        return 'TMS';
    }
}
